import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/app/config-service/app.config';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';
import { HomeActions } from 'src/app/home/ngrx/home-action-types';
import { BalanceService } from 'src/app/home/services/cardBalance.service';
import { AliasService } from '../../services/alias.service';
import { FavOpsService } from '../../services/favoriteOperations.service';
import { ProductService } from '../../services/getProducts.service';

const TOKEN_NOT_FOUND = 33;

@Component({
  selector: 'app-query-and-fav',
  templateUrl: './query-and-fav.component.html',
  styleUrls: ['./query-and-fav.component.scss', '../../card-operations.component.css']
})
export class QueryAndFavComponent {
  @Input() modalType!: string;
  @Output() onError = new EventEmitter();

  modalState = 'query'; // query || addfav || result -- 3ds || ccEntry
  addFavCardResult = false;
  addFavName = '';
  aliasNoControlWarningLabel = '';
  queryAlias = '';
  private cardAlias:string = '';
  balanceResult = '0';
  selectedCardProductCode = '0';

  isLoading = false;
  apiSettings = AppConfig.settings;

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
    private store: Store,
    public restGetBalance: BalanceService,
    public restAddFavorite: FavOpsService,
    public restGetProducts: ProductService,
    private aliasService: AliasService,
  ) { }

  onCloseModal(){
    this.onError.emit();
  }

  public getCardBalance(alias: string) {
    if (!this.aliasService.aliasControl(alias)) {
      this.toastr.error(
        this.translate.instant('CARDOPERATIONS_QUERY_ALIAS_CONTROL_ERROR')
      );
    } else {
      this.isLoading = true;
      new Promise((resolve, reject) => {
        alias = this.aliasService.reformatAlias(alias);
        this.restGetBalance.getCardBalanceResult(alias).subscribe(
          (resp:any) => {
            this.isLoading = false;
            if (resp.result.code !== 0) {
              console.log('');
            } else {
              resp.cardlist.forEach((el:any) => {
                this.balanceResult = el.balance;
                this.modalState = 'addfav';
              });
            }
          },
          (error:any) => {
            this.isLoading = false;
            this.toastr.error(
              this.translate.instant('CARDOPERATIONS_QUERY_ALIAS_CONTROL_ERROR')
            );
            reject(error);
          }
        );
      });
    }
  }

  public addtoFavorite = (desc: string) => {
    let alias = this.aliasService.reformatAlias(this.queryAlias);
    this.addFavName = desc;
    // const favInfo = favoriteItems.filter(card => card.favorite === aliasNo)[0];

    new Promise((resolve, reject) => {
      this.restAddFavorite
        .addFavoriteResult(alias, this.addFavName, '2')
        .subscribe(
          (resp) => {
            this.modalState = 'result';
            if (resp.result.code == TOKEN_NOT_FOUND) {
              console.log('Giriş Yapınız');
            } else {
              if (resp.favId) {
                const favoriteItem = {
                  type: Number('2'),
                  favorite: alias,
                  description: this.addFavName,
                  typeDescription: "Card",
                  favId: resp.favId
                }
                this.store.dispatch(HomeActions.FavoriteItemAdded({favoriteItem}))
                this.modalState = 'result';
                this.addFavCardResult = true;
              }
            }
          },
          (error:any) => {
            reject(error);
          }
        );
    });
  };

  onChangeQueryAliasNo = (text:any) => {
    this.queryAlias = this.aliasService.formatAlias(this.queryAlias, text);
    this.cardAlias = this.queryAlias.split('-').join('').slice(0, -1);

    this.selectedCardProductCode = '0';

    if (this.modalType === 'AddtoFav') {
      return;
    }

    if (this.aliasService.aliasControl(this.queryAlias)) {
      this.aliasNoControlWarningLabel = '';
      this.isLoading = true;
      new Promise((resolve, reject) => {
        let alias = this.aliasService.reformatAlias(this.queryAlias);

        this.restGetBalance.getCardBalanceResult(alias).subscribe(
          (resp:any) => {
            if (resp.result.code !== 0) {
              this.aliasNoControlWarningLabel = 'Giriş Yapınız!';
              this.onCloseModal();
            } else if (resp.result.code == 0) {
              resp.cardlist.forEach((el:cardDetailResModel) => {
                localStorage.setItem('card-type', el.cardType)
                this.isLoading = false;
                this.balanceResult = el.balance;
                this.selectedCardProductCode = el.product_code;
              });
            } else {
              this.isLoading = false;
              this.aliasNoControlWarningLabel = resp.result.message;
            }
          },
          (error:any) => {
            this.isLoading = false;
            reject(error);
          }
        );
      });
    } else {
      if (this.queryAlias.length > 5) {
        this.aliasNoControlWarningLabel = 'Kart numaranızı eksiksiz giriniz';
      }
    }
  };

}